import { Outlet } from "react-router-dom";
import { IRoutesModel } from "../models/routes";
import { TripRoutes } from "./trips/TripRoutes";
import { CustomerRoutes } from "./customers/CustomerRoutes";
import { CalenderRoutes } from "./calendars/CalenderRoutes";
import { AccountsRoutes } from "./accounts/AccountRoutes";
import { HistoriesRoutes } from "./histories/HistoriesRoutes";

export const dashboardRoutes = [
  {
    name: "Chuyến đi",
    path: "trips",
    element: <Outlet />,
    children: TripRoutes,
  },
  {
    name: "Khách hàng",
    path: "customers",
    element: <Outlet />,
    children: CustomerRoutes,
  },
  {
    name: "Lịch",
    path: "calendars",
    element: <Outlet />,
    children: CalenderRoutes,
  },
  {
    name: "Tài khoản",
    path: "accounts",
    element: <Outlet />,
    children: AccountsRoutes,
  },
  {
    name: "Lịch sử",
    path: "histories",
    element: <Outlet />,
    children: HistoriesRoutes,
  },
];
